export const MAX_CART_ITEM_QUANTITY = 999_999;

export function isCartQuantityLimitError(payload: unknown): boolean {
    return typeof payload === 'object'
        && payload !== null
        && (payload as {error?: unknown}).error === 'cart_quantity_limit_exceeded';
}
